const DB_MAPPING = {
  bankTransfers: 'bankTransfers',
  accounting_transactions: 'bankTransfers',
  deckOrders: 'deckOrders',
  accounting_invoices: 'deckOrders',
  transfers_orders: 'transfersOrdersMatches',
  transaction_invoice_matches: 'transfersOrdersMatches',
}

const applyLocalUpdates = (
  axiosResponse, // receive the axios response of the backend, containing documents that has changed
  updateCollections,
) => {
  const {
    data: {
      dbUpdates = [],
    } = {},
  } = axiosResponse
  // console.log('⚠️', dbUpdates)

  updateCollections(oldDb => {
    const newDb = { ...oldDb }

    dbUpdates.forEach(({ collectionName, docId, newDoc }) => {
      const existingDocs = Array.isArray(newDb[DB_MAPPING[collectionName]])
        ? newDb[DB_MAPPING[collectionName]]
        : []

      const alreadyExists = existingDocs.some(doc => doc.id === docId)

      const updatedDocs = alreadyExists
        ? existingDocs.map(doc => (doc.id === docId ? newDoc : doc))
        : [...existingDocs, newDoc]

      newDb[DB_MAPPING[collectionName]] = updatedDocs
    })

    return newDb
  })

  return axiosResponse
}

export default applyLocalUpdates
